var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReputation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5025 1.75H11.4975C10.575 3.07375 8.46 4 6 4V7.77475C6.00011 9.26736 6.49914 10.7171 7.41778 11.8935C8.33642 13.07 9.62194 13.9056 11.07 14.2675L12 14.5L12.93 14.2675C14.3781 13.9056 15.6636 13.07 16.5822 11.8935C17.5009 10.7171 17.9999 9.26736 18 7.77475V4C15.54 4 13.4288 3.07375 12.5025 1.75Z",
    stroke: "#E2CB2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1312 7.60045L11.4304 7.55985L11.5338 7.27621L11.8575 6.38805L12.2115 7.26262L12.3246 7.54186L12.6243 7.57242L13.8982 7.70232L13.1002 8.38672L12.8722 8.58225L12.9378 8.87536L13.1748 9.93526L12.2074 9.23873L11.904 9.02026L11.6086 9.24955L10.6671 9.98051L10.8656 8.91153L10.9203 8.61661L10.6859 8.42948L9.86301 7.77261L11.1312 7.60045ZM12.0749 5.79119C12.0741 5.79371 12.0731 5.79621 12.0722 5.79869L11.8499 5.71767L11.8457 5.71612L11.8432 5.71524L11.8426 5.71502L11.8398 5.71399L11.6025 5.6275L11.8456 5.71172L11.8484 5.71269L12.0749 5.79119ZM11.6212 5.80447C11.6207 5.80335 11.6203 5.80223 11.6199 5.8011L11.6198 5.8011L11.6212 5.80447Z",
    stroke: "#E2CB2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4H3.75",
    stroke: "#E2CB2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.25H3.75",
    stroke: "#E2CB2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.5H3.75",
    stroke: "#E2CB2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.75H4.5",
    stroke: "#E2CB2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 4H20.25",
    stroke: "#E2CB2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6.25H20.25",
    stroke: "#E2CB2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 8.5H20.25",
    stroke: "#E2CB2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.75H19.5",
    stroke: "#E2CB2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReputation);
export default __webpack_public_path__ + "static/media/reputation.9b7516a7ed28e9e8d1d44b6fe79efb90.svg";
export { ForwardRef as ReactComponent };